export default "__VITE_ASSET__0debb196__"